"use client";
import Error from "@/app/(root)/error";
export default Error;
